import { State } from '../../types';

export const southCarolina: State = {
  name: 'South Carolina',
  abbreviation: 'SC',
  terms: [
    {
      word: 'Alcolu',
      phonetic: 'al-CUH-loo',
      // audioUrl: '/audio/alcolu.mp3',
      description: 'An unincorporated community in Clarendon County.'
    },
    {
      word: 'Beaufort',
      phonetic: 'BYOO-furt',
      // audioUrl: '/audio/beaufort_sc.mp3',
      description: 'A city in Beaufort County; not to be confused with Beaufort, NC.'
    },
    {
      word: 'Blenheim',
      phonetic: 'BLEN-um',
      // audioUrl: '/audio/blenheim.mp3',
      description: 'A town in Marlboro County, known for its namesake ginger ale.'
    },
    {
      word: 'Bonneau',
      phonetic: 'BUN-oh',
      // audioUrl: '/audio/bonneau.mp3',
      description: 'A town in Berkeley County.'
    },
    {
      word: 'Cayce',
      phonetic: 'KAY-see',
      // audioUrl: '/audio/cayce.mp3',
      description: 'A city in Lexington County.'
    },
    {
      word: 'Chapin',
      phonetic: 'CHAY-pin',
      // audioUrl: '/audio/chapin.mp3',
      description: 'A town in Lexington County.'
    },
    {
      word: 'Cheraw',
      phonetic: 'chuh-RAW',
      // audioUrl: '/audio/cheraw.mp3',
      description: 'A town in Chesterfield County.'
    },
    {
      word: 'Clemson',
      phonetic: 'CLEMP-sun',
      audioUrl: '/audio/clemson.mp3',
      description: 'City and university in western South Carolina'
    },
    {
      word: 'Clinton',
      phonetic: 'CLIN-nin',
      // audioUrl: '/audio/clinton_sc.mp3',
      description: 'A city in Laurens County.'
    },
    {
      word: 'Eutawville',
      phonetic: 'YOU-tah-vil',
      // audioUrl: '/audio/eutawville.mp3',
      description: 'A town in Orangeburg County.'
    },
    {
      word: 'Galivants Ferry',
      phonetic: 'GAL-uh-vints FAIR-ee',
      // audioUrl: '/audio/galivants_ferry.mp3',
      description: 'An unincorporated community in Horry County.'
    },
    {
      word: "Gullah",
      phonetic: "GUL-lah",
      description: "The culture and language of African Americans in the Lowcountry, blending African and English influences.",
    },
    {
      word: "Haint Blue",
      phonetic: "HAYNT BLOO",
      description: "A color painted on porches and doors to ward off evil spirits, rooted in Gullah traditions.",
    },
    {
      word: 'Lancaster',
      phonetic: 'LANG-kast-er',
      // audioUrl: '/audio/lancaster_sc.mp3',
      description: 'A city in Lancaster County.'
    },
    {
      word: "Lowcountry Boil",
      phonetic: "LOH-kun-tree BOIL",
      description: "A regional dish featuring shrimp, sausage, corn, and potatoes, central to southern gatherings.",
    },
    {
      word: 'Lugoff',
      phonetic: 'LOO-goff',
      // audioUrl: '/audio/lugoff.mp3',
      description: 'A census-designated place in Kershaw County.'
    },
    {
      word: 'Okatie',
      phonetic: 'OH-kuh-tee',
      // audioUrl: '/audio/okatie.mp3',
      description: 'A rural area in Beaufort and Jasper counties, known for its scenic beauty and proximity to the Lowcountry.'
    },
    {
      word: "Okra",
      phonetic: "OH-krah",
      description: "A vegetable widely used in southern and Gullah cuisine, often in stews or fried.",
    },
    {
      word: "Sweetgrass Basket",
      phonetic: "SWEET-grass BAS-ket",
      description: "A traditional Gullah craft made from local sweetgrass, often sold in Charleston markets.",
    }
  ]
};